<template>
  <div id="AllJournalList">
    <div v-if="!currIsNo" class="CurrentCollection">
      <div class="left_Title">
        <p>
          <i class="iconfont iconjieguo"></i>
          <span class="aqt_lang_mn titlefont">{{ $t('m.seareturn') + '&nbsp;' + '(' + currList.length + ')'|U2M }}</span>
        </p>
        <p></p>
      </div>
      <div class="list_Content aqt_su">
        <div class="aqt_list_lists_one" v-for="(item,index) in currList" :key="index"
             @click.stop="getDetail(item.magazine_id,item,item.isxq,'one',item.issn)">
          <div class="aqt_top aqt_ce_ve" v-if="item.imgm">
            <img v-lazy="item.imgm?$webcrypto.get(item.imgm):''" alt/>
            <p v-if="item.issn" class="journal_issn aqt_no_su">{{ item.issn }}</p>
          </div>
          <div class="aqt_center">
            <!-- 期刊名字 -->
            <div class="aqt_title" v-if="item.titlelang&&(item.titlelang.mn||item.titlelang.zh)">
              <p v-if="item.titlelang.mn" class="titlefont aqt_lang_mn"
                 v-html="U2M(item.titlelang.mn)"></p>
              <p v-else class="titlefont aqt_su"
                 v-html="U2M(item.titlelang.zh)"></p>
            </div>
            <!--          期刊标识-->
            <div class="aqt_tip"
                 v-if="item.magazineclasstitlelang&&(item.magazineclasstitlelang.mn||item.magazineclasstitlelang.zh)">
              <p v-if="item.magazineclasstitlelang.mn" class="contentfont aqt_lang_mn"
                 v-html="U2M(item.magazineclasstitlelang.mn)"></p>
              <p v-else class="contentfont aqt_su"
                 v-html="U2M(item.magazineclasstitlelang.zh)"></p>
            </div>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
    </div>

    <div v-if="!isNo" class="allCollection">
      <div class="left_Title">
        <p>
          <i class="iconfont iconjieguo"></i>
          <span class="aqt_lang_mn titlefont">{{ $t('m.seareturn') + '&nbsp;' + '(' + total + ')'|U2M }}</span>
        </p>
        <p></p>
      </div>
      <div class="list_Content aqt_su" ref="Content_Width">
        <div class="aqt_list_lists_one" v-for="(item,index) in list" :key="index"
             @click.stop="getDetail(item.magazine_id,item,item.isxq,'all',item.issn)">
          <div class="aqt_top aqt_ce_ve" v-if="item.imgm">
            <img v-lazy="item.imgm?$webcrypto.get(item.imgm):''" alt/>
            <p v-if="item.issn" class="journal_issn aqt_no_su">{{ item.issn }}</p>
          </div>
          <div class="aqt_center">
            <!-- 期刊名字 -->
            <div class="aqt_title" v-if="item.titlelang&&(item.titlelang.mn||item.titlelang.zh)">
              <p v-if="item.titlelang.mn" class="titlefont aqt_lang_mn"
                 v-html="U2M(item.titlelang.mn)"></p>
              <p v-else class="titlefont aqt_su"
                 v-html="U2M(item.titlelang.zh)"></p>
            </div>
            <!--          期刊标识-->
            <div class="aqt_tip"
                 v-if="item.magazineclasstitlelang&&(item.magazineclasstitlelang.mn||item.magazineclasstitlelang.zh)">
              <p v-if="item.magazineclasstitlelang.mn" class="contentfont aqt_lang_mn"
                 v-html="U2M(item.magazineclasstitlelang.mn)"></p>
              <p v-else class="contentfont aqt_su"
                 v-html="U2M(item.magazineclasstitlelang.zh)"></p>
            </div>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
      <div class="page">
        <PageMn v-if="!isNo" :total="total" :current="current_page"
              :pageSize="per_page" @getPager="getPager">
        </PageMn>
<!--        <Page v-if="!isNo" :total="total" :current="current_page"-->
<!--              :page-size="per_page" @getPager="getPager">-->
<!--        </Page>-->

      </div>
    </div>

    <div v-if="isNo&&currIsNo" class="nomassage">
      <p class="aqt_lang_mn titlefont">{{ $t('m.noData') | U2M }}</p>
    </div>
    <!--    加载动画-->
    <AqtSpin v-if="isSpin"></AqtSpin>
  </div>
</template>
<script>
export default {
  data() {
    return {
      total: 0,
      current_page: 1,
      per_page: 0,
      list: [],
      isNo: false,
      isSpin: false,
      isSpin_press: false,
      query: {
        page: 1,
        per_page: '',
        magazineclass_id: '',
        library_id: '',
        title: '',
        issn:'',
        keymn:'',//首字母
      },

      currList: [],
      currIsNo: false,
    }
  },
  methods: {
    getDetail(id, item,isxq,type,issn) {
      let that = this
      if(isxq==0||!issn){
        that.$Message.warning(that.$t('m.no_permission'));
        return
      }
      that.$store.dispatch('saveUserBehavior', {
        type: 2,
        path: that.$route.path,
        mark: '点击' + (item.titlelang.zh || item.titlelang.mn)
      }).then(() => {
      })

      let data = {
        data: '',
        id: id,
        type:type
      }
      that.$emit('goJournal', data)

    },
    getPager(page) {
      let that = this
      that.list = []
      that.query.page = page
      that.getList()
    },
    getList() {
      let that = this
      that.isSpin = true
      that.list = []
      //保存用户搜索记录
      if (that.query.page == 1) {
        that.$store.commit('SET_PuserSearch', [JSON.stringify(that.query), that.$route.path, that.$route.meta.title, 2],)
        that.$store.dispatch('getHedcircle')
      }
      that.query.library_id = that.library_id
      that.$httpsencrypt.post(`api/web/v3/magazine/newlistpc`, that.query)
          .then((val) => {
            if (val.code == 200 && val.data.length) {
              that.total = val.pages.total
              that.current_page = val.pages.current_page
              that.per_page = val.pages.per_page * 1
              that.list = val.data
              that.isSpin = false
              that.isNo = false
            } else {
              that.list = []
              that.isNo = true
              that.isSpin = false
              that.total = 0
            }

          }).catch(e => {
            that.list = []
            that.isNo = true
            that.isSpin = false
            that.total = 0
          }
      )
    },
    getNowList() {
      let that = this
      that.isSpin = true
      that.currList = []

      that.query.library_id = that.library_id
      that.$httpsencrypt.post(`api/web/v3/magazine/newindexlibpc`, that.query)
          .then((val) => {
            if (val.code == 200 && val.data.length) {
              that.currList = val.data
              that.isSpin = false
              that.currIsNo = false
            } else {
              that.currList = []
              that.currIsNo = true
              that.isSpin = false
            }

          }).catch(e => {
            that.currList = []
            that.currIsNo = true
            that.isSpin = false
          }
      )
    },
    //父组件调用请求数组
    ParentCom(val) {
      let that = this
      that.isNo = false
      that.query.title = val.title
      that.query.magazineclass_id = val.magazineclass_id
      that.query.issn = val.issn
      that.query.keymn = val.keymn
      that.getList()
      that.getNowList()
    },
  },
  created() {
    this.$emit('getWidth')
    let info={
      type: 2,
      path: this.$route.path,
      mark: '杂志列表',
    }
    this.$store.dispatch('saveUserBehavior', info).then(() => {
    })
  },
  mounted() {
    let that = this
    let kk = that.$refs.Content_Width.clientWidth / 235
    let tt = that.$refs.Content_Width.clientHeight / 215
    that.query.per_page = Math.floor(kk) * Math.floor(tt)
    that.query.page = 1

  },
  computed: {
    // 馆藏id
    library_id() {
      let vv = localStorage.getItem("theme_color") ? JSON.parse(this.$crypto.get(localStorage.getItem("theme_color"))).library_id : 28;
      return vv
    },
    // 用户id
    member_id() {
      let mm = localStorage.getItem("userInfoMemberId") ? JSON.parse(this.$crypto.get(localStorage.getItem("userInfoMemberId"))).member_id : ''
      return mm
    },
  },
}
</script>

<style lang="less" scoped>
#AllJournalList {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  position: relative;
  justify-content: flex-start;
  overflow-x: auto;

  .nomassage {
    padding: 0 1rem;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    display: -ms-flexbox;
    display: flex;
    font-size: 2rem;
    color: #888888;
  }

  .CurrentCollection {
    height: 100%;
    display: flex;
    margin-right: 1rem;
  }

  .allCollection{
    min-width: 100%;
    height: 100%;
    display: flex;
  }

  .left_Title {
    width: 5.4rem;
    height: 100%;
    background: #ffffff;
    margin-right: 0.5rem;
    padding-top: 2.7rem;
    display: flex;
    justify-content: flex-end;

    p:nth-child(1) {
      width: 2.4rem;
      color: var(--themeColor);
      font-size: 2rem;
      line-height: 2.4rem;

      i {
        font-size: 2.4rem;
      }
    }

    p:nth-child(2) {
      width: 0.8rem;
      height: 16.2rem;
      background: var(--themeColor);
      margin-left: 1rem;
    }
  }

  .list_Content {
    width: 100%;
    height: 100%;
    //overflow-x: auto !important;
    //overflow-y: hidden;

    .aqt_list_lists_one {
      width: 22rem;
      height: 20rem;
      background-color: #ffffff;
      cursor: pointer;
      box-shadow: 1rem 1.2rem 1.5rem -1.5rem;
      border-radius: 0.3rem;
      margin-right: 1.5rem;
      margin-bottom: 1.5rem;
      float: left;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;

      .aqt_top {
        width: calc(100% - 9rem);
        height: 100%;
        position: relative;
        overflow: hidden;
        padding: 1.5rem 0 1.5rem 1.5rem;


        img {
          height: inherit;
          width: 100%;
          display: inline-flex;
        }

        img[lazy="loading"] {
          height: auto !important;
        }

        .journal_issn {
          width: calc(100% - 1.5rem);
          height: 30px;
          position: absolute;
          left: 15px;
          bottom: 15px;
          background: rgba(0, 0, 0, 0.4);
          color: #ffffff;
          font-size: 15px;
          line-height: 30px;
          text-align: center;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .aqt_center {
        height: 100%;
        width: 9rem;
        padding: 1.5rem 0;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        //margin-right: 1rem;

        .aqt_lang_mn1 {
          writing-mode: vertical-lr;
        }

        .aqt_title {
          width: 5rem;
          height: 100%;
          color: #888888;
          //display: table;
          overflow: hidden;
          margin: 0 0.4rem 0 0.7rem;

          span {
            line-height: 3rem;
            font-size: 1.8rem;
            margin-bottom: 1rem;
          }

          p {
            width: 5rem;
            line-height: 2.6rem;
            font-size: 1.8rem;
            height: 100%;
            display: table-cell;
            vertical-align: middle;
          }
        }

        .aqt_tip {
          width: 2rem;
          height: 100%;
          overflow: hidden;
          //padding-top: 1.5rem;

          p {
            line-height: 2rem;
            font-size: 1.46rem;
            color: var(--themeColor);
          }
        }
      }

    }

    .aqt_list_lists_one:hover {
      background: #F7FAF1;
    }
  }

  .page {
    width: 5rem;
    height: 100%;
  }
}
#AllJournalList::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 0.4rem; /*高宽分别对应横竖滚动条的尺寸*/
  height: 0.8rem;
}

#AllJournalList::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 0.5rem;
  -webkit-box-shadow: inset 0 0 0.5rem rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

#AllJournalList::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 0.5rem rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
</style>

<style lang="less">
#AllJournalList{
  .ivu-tooltip-popper {
    max-height: 25rem !important;

    .ivu-tooltip-inner {
      width: 100%;
      white-space: pre-line !important;

      p {
        white-space: pre-line !important;
      }
    }
  }
}
</style>

